// extracted by mini-css-extract-plugin
module.exports = {"main":"ZonesTable-module--main--2F-gy","compareBox":"ZonesTable-module--compareBox--ugsaS"};